export default __webpack_public_path__ + "static/media/sdk-github-screen.f02fde83.svg";